const STORAGE_KEY = "mp:visitCounts";

function readCounts() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function recordVisit(path) {
  if (!path) return;
  try {
    const counts = readCounts();
    counts[path] = (counts[path] || 0) + 1;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(counts));
  } catch (e) {}
}

export function getTopVisited(limit = 4) {
  const counts = readCounts();
  return Object.keys(counts)
    .map((path) => ({ path, count: counts[path] }))
    .sort((a, b) => b.count - a.count)
    .slice(0, limit);
}
